function navbar(theme: any, ownerState: any) {
  const { palette, boxShadows, functions, transitions, borders } = theme;
  const { transparentNavbar, absolute, light, darkMode } = ownerState || {};

  const { white, dark, text, background, grey } = palette;
  const { navbarBoxShadow } = boxShadows;
  const { rgba, pxToRem } = functions;
  const { borderRadius } = borders;
  const { breakpoints } = theme;

  return {
    boxShadow: absolute ? "none" : navbarBoxShadow,
    backdropFilter: absolute ? "none" : `saturate(200%) blur(${pxToRem(30)})`,
    backgroundColor: darkMode ? background.paper : white.main,
    backgroundImage: "none",
    border: `1px solid ${rgba(darkMode ? grey[700] : grey[200], darkMode ? 0.45 : 0.8)}`,
    color: darkMode ? text?.main || "#ffffff" : (text?.main || dark.main),
    top: 0,
    width: "100%",
    minHeight: pxToRem(56),
    display: "grid",
    alignItems: "center",
    borderRadius: borderRadius.md,
    paddingTop: pxToRem(2),
    paddingBottom: pxToRem(2),
    paddingRight: pxToRem(8),
    paddingLeft: pxToRem(8),
    [breakpoints.down("lg")]: {
      paddingTop: pxToRem(8),
      paddingBottom: pxToRem(8),
      paddingRight: pxToRem(12),
      paddingLeft: pxToRem(12),
    },

    "& > *": {
      transition: transitions.create("all", {
        easing: transitions.easing.easeInOut,
        duration: transitions.duration.standard,
      }),
    },

    "& .MuiToolbar-root": {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      width: "100%",
      minHeight: "auto",
      padding: `${pxToRem(2)} ${pxToRem(4)}`,
    },
  };
}

const navbarContainer = ({ breakpoints }: any) => ({
  flexDirection: "column",
  alignItems: "flex-start",
  justifyContent: "center",
  width: "100%",
  minWidth: 0,
  px: 0,
  pt: 0,
  pb: 0,

  [breakpoints.up("md")]: {
    flexDirection: "row",
    alignItems: "center",
    paddingTop: "0",
    paddingBottom: "0",
  },
});

const navbarRow = ({ breakpoints }: any, { isMini }: any) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-start",
  width: "100%",

  [breakpoints.up("md")]: {
    justifyContent: isMini ? "flex-start" : "flex-start",
    width: isMini ? "100%" : "max-content",
  },

  [breakpoints.up("xl")]: {
    justifyContent: "flex-start !important",
    width: "max-content !important",
  },
});

const navbarIconButton = ({ typography: { size }, breakpoints }: any) => ({
  px: 1,

  "& .material-icons, .material-icons-round": {
    fontSize: `${size.xl} !important`,
  },

  "& .MuiTypography-root": {
    display: "none",

    [breakpoints.up("sm")]: {
      display: "inline-block",
      lineHeight: 1.2,
      ml: 0.5,
    },
  },
});

const navbarMobileMenu = ({ breakpoints }: any) => ({
  display: "inline-block",
  lineHeight: 0,

  [breakpoints.up("xl")]: {
    display: "none",
  },
});

export { navbar, navbarContainer, navbarRow, navbarIconButton, navbarMobileMenu };
